import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrencesEvolution = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Evolução do total dos ocorrências no exercício'}
            horizontal={false}
            subtitles={chartData?.monthlyOcurrencesEvolution?.map((item) => item.description)}
            values={chartData?.monthlyOcurrencesEvolution?.map((item) => item.total || 0)}
        />
    );
};